
const selectors = {
	/**
	 * This is technically only needed temporarily to lazy-fetch longId and env
	 * in a resolver. Maybe there are better ways to deal with this?
	 */
	getExtensionData: (state) => state.extension,
	getLongId: (state) => state.longId,
	getEnv: (state) => state.env,
	getSdkVersion: (state) => state.sdkVersion,
	getSdkIntegrity: (state) => state.sdkIntegrity,
	getSdk: (state) => state.sdk,
	isHostedModeForced: (state) => state.forceHostedFlow,
	/**
	 * Validity only makes sense for Cards payment method
	 * https://checkoutdocs.payoneer.com/docs/payment-button#listening-for-validation-events
	 */
	getIsValid: (state) =>
		state.activePaymentMethod !== 'payoneer-checkout' ||
		state.isValid,
	getActivePaymentMethod: (state) => state.activePaymentMethod,
	getAvailableDropInComponents: (state) => state.availableDropInComponents,
	getOrderId: (state) => state.orderId,
	getOnPaymentDeclinedNonce: (state) => state.onPaymentDeclinedNonce,
};

export default selectors;
